import { scopeViewCardh4i41xz7rdh8 as scopeViewCard } from './cards.mjs';
import {
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  navigateOrDialog1m0cnx3luzasq as navigateOrDialog,
} from '../../../nav/crowpay.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  contains2gm06f5aa19ov as contains,
  asSequence2phdjljfh9jhx as asSequence,
  average1u332mxgzjdwv as average,
  distinct10qe1scfdvu5k as distinct,
  withIndex37cl61h9v5txo as withIndex,
  reversed22y3au42jl32b as reversed,
  plus310ted5e4i90h as plus,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { plus18eogev54fmsa as plus_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  lensUnread1tcpdysie4g78 as lensUnread,
  get_session9cytjmfbg8nd as get_session,
} from '../../../../../sdk/UserSession.mjs';
import {
  handleOne3ny7r4k654tcd as handleOne,
  isUnread2wfj6ps7oiv9h as isUnread,
} from '../../../../../extensions/HasReadBy.ext.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
  minus1paei8txflgx9 as minus,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import {
  WorkItemWeights1puyl4v7xr6t7 as WorkItemWeights,
  workItemTableHeader1i5k4rlwsgce6 as workItemTableHeader,
  workItemTableSummary2lie214j07e5o as workItemTableSummary,
  workItemTableRow1fg7z95rbicqi as workItemTableRow,
} from './tables.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance,
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  get_darkSection25mxxvxk8ts3b as get_darkSection,
} from '../../../../theming/sections.mjs';
import {
  get_withoutPadding21hnjxk91b1qc as get_withoutPadding,
  GroupedInformationSemantic_getInstance10la8ntbgzaf6 as GroupedInformationSemantic_getInstance,
} from '../../../../theming/appTheme.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme,
  ExpandButtonSemantic_getInstance3eedzzd1fkase as ExpandButtonSemantic_getInstance,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  SecondaryButtonSemantic_getInstance1ksz6yxlolvnl as SecondaryButtonSemantic_getInstance,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
} from '../../../../theming/buttons.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  unreadIconVisibley9o01zmxr3gz as unreadIconVisible,
  actionIcon360epyywhabwj as actionIcon,
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
  escalationIconmtio0lqe8r8o as escalationIcon,
  timerRunningIcon3mra8cwh7awq2 as timerRunningIcon,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  divkhq3vjih9fcw as div,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  get_dragHandlemufcu3tsewag as get_dragHandle,
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../../../icons.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  DragShadowu6jlihuvhlhp as DragShadow,
  getMany3bs02247im3ra as getMany,
  percentComplete22ixcedvdan2 as percentComplete,
  renderPercent3ullukkakwyrl as renderPercent,
  resize3py5p2yrjp6p7 as resize,
  filter31kgiqs90is7g as filter,
  awaitSuspendingfmims6z9kmaq as awaitSuspending,
} from '../../../../../utils/utils.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAndMarkAsReadAction24de04tkd12ld as expandAndMarkAsReadAction,
  expandAction2iatt63opw8h9 as expandAction,
} from '../../../expansion.mjs';
import {
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  maxOrNull2yp8rzwwvng8y as maxOrNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../../../theming/Titles.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  get_pending3bzoyvzwzq8kn as get_pending,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { priceWithChangedayxt0y21soj as priceWithChange } from '../../../priceChanges.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../../../../theming/states.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  Indent_HalfSection_getInstance3e9u4kbpkw4rx as Indent_HalfSection_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../../../space.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  lineItemBanners14ilhfznw9y75 as lineItemBanners,
  renderLineItemDetails23mbed1k3mdfc as renderLineItemDetails,
} from './lineItemDetails.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_1 } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../../keyValue.mjs';
import {
  forEachMaybeReorderable1aeoqjpfy2fje as forEachMaybeReorderable,
  reorderts8zja415q79 as reorder,
} from '../../../reordering.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../../../theming/banners.mjs';
import { titleCasej01kvzva6qlf as titleCase } from '../../../../../../../../lightning-server-kiteui-client/com/lightningkite/casing.mjs';
import {
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
} from '../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  applyReactiveActionFormatting11beyf0tv05i4 as applyReactiveActionFormatting,
  ButtonActionqmmxsu493eh2 as ButtonAction,
  Companion_instance1hgjusdx1kcma as Companion_instance_0,
} from '../../../../../utils/ButtonAction.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
  LineItemState_OnHold_getInstance5v65qotr6ndv as LineItemState_OnHold_getInstance,
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
  ProjectState_PreSubstantialCompletion_getInstancep7r5dsq5lipe as ProjectState_PreSubstantialCompletion_getInstance,
  LineItemState_InProgress_getInstance30c0b4tuqukui as LineItemState_InProgress_getInstance,
  LineItemState_WorkingOnRemedy_getInstanceklan96hlrfx7 as LineItemState_WorkingOnRemedy_getInstance,
  ProjectState_PendingStart_getInstance2dqkzmcm0blyg as ProjectState_PendingStart_getInstance,
  ProjectState_Disputed_getInstance3jjamycmvlpib as ProjectState_Disputed_getInstance,
  LineItemState_RequestingReview_getInstance2ojeopd3nid3v as LineItemState_RequestingReview_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { CompletionFlowPermissionsj7m9votfuuvc as CompletionFlowPermissions } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionFlowPermissions.mjs';
import { RequestComplete2fbpvksxlxjbf as RequestComplete } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from '../../../../../sdk/apiOptions.mjs';
import {
  setOf1u3mizs95ngxo as setOf_0,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  LineItem2rt64afaiyloc as LineItem,
  ScopeView2pjeasrtqdymw as ScopeView,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_scopeSet9qq32a9d0llm as get_scopeSet,
  get_state1s5baftgdwrse as get_state,
  get_started14uxkm9fjiknx as get_started,
} from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_1 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { MassModification2g7vooufrvzd as MassModification } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/MassModification.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { requiresAction13nb01xm2r5gu as requiresAction } from '../../../../../extensions/FlowPermissions.ext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  modify2eca96i8s7hc2 as modify,
  set_value1vvx5pkb20ebv as set_value,
} from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../../../utils/Draft.ext.mjs';
import {
  Subscopelwws6cwdmjzk as Subscope,
  CreateScopeViewDialog2bw9ryrzjhk1t as CreateScopeViewDialog,
} from '../../../../dialogs/NewScopeViewDialog.mjs';
import { Draft3jz09icer2h2u as Draft } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { EditScopeViewDialog24e1qiqowum8p as EditScopeViewDialog } from '../../../../dialogs/EditScopeViewDialog.mjs';
import { Movepj4bxmsunu5w as Move } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { WorkItemRequestSignOffDialog3jlywf6lxbyl7 as WorkItemRequestSignOffDialog } from '../../../../dialogs/RequestSignOffDialog.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../../../dialogs/GenericDialog.mjs';
import {
  repeatForScopeSets2sd4ktutrrxkj as repeatForScopeSets,
  repeatForScopeSets_BREAK_FOR_TESTING1o9rhfik0wyta as repeatForScopeSets_BREAK_FOR_TESTING,
} from '../../../../../utils/actions.mjs';
import {
  Companion_instance3euo5q27joywz as Companion_instance_2,
  ScopeSetInfo20wjokolfm84l as ScopeSetInfo,
} from './LineItemCompletionForm.mjs';
import { ScopeSetReviewDialog3daipl4340b3e as ScopeSetReviewDialog } from '../../../../dialogs/ScopeSetReviewDialog.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderScopeView(_this__u8e3s4, scope, dragData, writer) {
  // Inline function 'kotlin.with' call
  return get_viewIsNarrow(writer) ? scopeViewCard(_this__u8e3s4, scope, dragData, writer) : renderScopeViewWide(_this__u8e3s4, scope, dragData, writer);
}
function renderScopeViewWide(_this__u8e3s4, scope, dragData, writer) {
  // Inline function 'kotlin.with' call
  var expand = Signal().fak(false);
  var subscopes = remember(VOID, VOID, VOID, ($this$remember) => {
    var scope_0 = $this$remember.baj(scope);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.lgy());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (equals(element.q7z_1, scope_0.k7z_1)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var allItems = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.baj(subscopes);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$3 = item.k7z_1;
      destination.v(tmp$ret$3);
    }
    var scopeIds = plus_0(toSet(destination), $this$remember.baj(scope).k7z_1);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.tgm());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList().w();
    var _iterator__ex2g4s_0 = tmp0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element = _iterator__ex2g4s_0.o1();
      if (contains(scopeIds, element.nfy())) {
        destination_0.v(element);
      }
    }
    return destination_0;
  });
  var thisScopesItems = remember(VOID, VOID, VOID, ($this$remember) => {
    var scope_0 = $this$remember.baj(scope);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(allItems);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (equals(element.nfy(), scope_0.k7z_1)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var example = get_waitForNotNull(lens(allItems, renderScopeViewWide$lambda));
  var isManager = remember(VOID, VOID, VOID, renderScopeViewWide$lambda_0);
  var tmp = get_rawSession();
  var scopeUnread = lensUnread(tmp, (session) => {
    var tmp = handleOne(session.ufv_1, ($this$handleOne, it) => $this$handleOne.baj(scope));
    var tmp_0 = tmp.sfw(session.mfv_1.eft(VOID, ($this$isUnread, it) => {
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$isUnread.baj(allItems);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$12 = item.hf9_1;
        destination.v(tmp$ret$12);
      }
      return destination;
    }));
    var tmp_1 = tmp_0.sfw(session.zfv_1.eft(VOID, ($this$isUnread, it) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$isUnread.baj(_this__u8e3s4.xgz());
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'kotlin.collections.map' call
        var this_0 = $this$isUnread.baj(allItems);
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s_0 = this_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp$ret$15 = item.kf9_1;
          destination_0.v(tmp$ret$15);
        }
        if (contains(destination_0, element.f5p_1)) {
          destination.v(element);
        }
      }
      return destination;
    }));
    var tmp_2 = tmp_1.sfw(session.rfv_1.eft(VOID, ($this$isUnread, it) => {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$isUnread.baj(_this__u8e3s4.ugm());
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        // Inline function 'kotlin.collections.map' call
        var this_0 = $this$isUnread.baj(allItems);
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s_0 = this_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp$ret$21 = item.kf9_1;
          destination_0.v(tmp$ret$21);
        }
        if (contains(destination_0, element.n7w_1)) {
          destination.v(element);
        }
      }
      return destination;
    }));
    var tmp_3 = tmp_2.sfw(session.nfv_1.eft(VOID, ($this$isUnread, it) => {
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0 = $this$isUnread.baj(allItems);
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var list = element.jf9_1;
        addAll(destination, list);
      }
      return destination;
    }));
    return tmp_3.sfw(session.mfv_1.ofu(VOID, VOID, ($this$creditsIsUnread) => {
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$creditsIsUnread.baj(allItems);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$30 = item.hf9_1;
        destination.v(tmp$ret$30);
      }
      return destination;
    }));
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  var weights = new (WorkItemWeights())(get_viewIsNarrow(view), _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance()));
  var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var $this$outer = view_0;
  $this$outer.zb8(get_px(0));
  launch($this$outer, VOID, VOID, renderScopeViewWide$slambda_0(scope, $this$outer, expand));
  dynamicTheme($this$outer, ($this$dynamicTheme) => $this$dynamicTheme.baj(expand) ? get_withoutPadding(SectionSemantic_getInstance()) : null);
  var tmp_1 = $this$outer.ibb(get_expandButtonTheme($this$outer), get_expanding($this$outer));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())($this$outer.pc());
  var tmp0_elvis_lhs_1 = $this$outer.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? $this$outer : tmp0_elvis_lhs_1;
  $this$outer.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_px(0));
  var tmp_2 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().xg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  get_centered(view_2);
  unreadIconVisible(view_2, ($this$unreadIconVisible) => $this$unreadIconVisible.baj($this$unreadIconVisible.baj(scopeUnread)));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance();
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_2, view_2);
  if (!(dragData == null)) {
    var tmp_3 = get_centered(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (IconView())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.ebb(p_3, view_3);
    var tmp0_vertical = get_px(0);
    var tmp1_horizontal = div(view_3.kba().hb0_1, 2);
    view_3.hba(Edges().cd0(tmp1_horizontal, tmp0_vertical));
    view_3.ebu('drag');
    view_3.qbt(get_dragHandle(Companion_getInstance_0()));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = IconView$_get_dragData_$ref_4jg2ny(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('dragData', 0, tmp_4, tmp_5, IconView$_set_dragData_$ref_k36t82(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp$ret$37 = $this$reactiveScope.baj(dragData).fcy(VOID, VOID, DragShadow($this$outer, Align_Start_getInstance()));
      this_0.set(tmp$ret$37);
      return Unit_instance;
    });
    view_1.fbb(p_3, view_3);
    view_1.jbb(tmp_3, view_3);
  }
  var tmp_6 = view_1.ibb(view_1.ibb(get_expanding(view_1), view_1.hbb(ExpandButtonSemantic_getInstance())), get_unpadded(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_4 = view_1.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
  view_1.ebb(p_4, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.xbm(false);
  view_5.zb8(weights.vhx_1);
  var tmp_7 = view_5.ibb(weight(view_5, weights.qhx_1), get_compact(view_5));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.xbm(false);
  view_6.zb8(get_AppDimensions().mg2_1);
  view_6.jbb(get_centered(view_6), expandIcon(view_6, expand));
  var tmp_8 = get_centered(view_6);
  view_6.jbb(tmp_8, actionIcon(view_6, VOID, ($this$actionIcon) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$actionIcon.baj(allItems);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$42 = item.kf9_1;
      destination.v(tmp$ret$42);
    }
    var ids = destination;
    var tmp = asSequence(getMany($this$actionIcon.baj(_this__u8e3s4.mgf()), ids));
    var tmp0_elvis_lhs = maxOrNull(mapNotNull(tmp, renderScopeViewWide$lambda$lambda));
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }));
  var tmp_9 = get_centered(view_6);
  view_6.jbb(view_6.ibb(tmp_9, shownWhen(view_6, VOID, ($this$shownWhen) => $this$shownWhen.baj(scope).p7z_1 && !$this$shownWhen.baj(expand))), scopeSetIcon(view_6, get_rem(1)));
  var tmp_10 = get_centered(view_6);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_11 = KMutableProperty0();
  var tmp_12 = TextView$_get_content_$ref_4pzcwl(view_7);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(view_7));
  reactiveScope(view_7, ($this$reactiveScope) => {
    var tmp$ret$45 = $this$reactiveScope.baj(scope).m7z_1;
    this_1.set(tmp$ret$45);
    return Unit_instance;
  });
  view_6.fbb(p_7, view_7);
  view_6.jbb(tmp_10, view_7);
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_7, view_6);
  var tmp_13 = weight(view_5, weights.whx() + 0.2);
  var tmp_14 = view_5.ibb(tmp_13, shownWhen(view_5, VOID, ($this$shownWhen) => !$this$shownWhen.baj(expand)));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_8 = view_5.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
  view_5.ebb(p_8, view_8);
  view_8.xbm(false);
  view_8.zb8(weights.vhx_1);
  var tmp_15 = view_8.ibb(weight(view_8, weights.rhx_1), get_centered(view_8));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Frame())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.ebb(p_9, view_9);
  var tmp_16 = get_centered(view_9);
  var tmp_17 = ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.baj(allItems);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$56 = element.hf9_1.f6l_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$56);
    }
    var tmp$ret$57 = sum;
    return new (MonetaryValue())(tmp$ret$57);
  };
  view_9.jbb(tmp_16, priceWithChange(view_9, VOID, tmp_17, ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.baj(allItems);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$58 = MonetaryValue__minus_impl_jw9qyp(element.hf9_1.f6l_1, element.hf9_1.n6k_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$58);
    }
    var tmp$ret$59 = sum;
    return new (MonetaryValue())(tmp$ret$59);
  }));
  view_8.fbb(p_9, view_9);
  view_8.jbb(tmp_15, view_9);
  var paid = remember(VOID, VOID, VOID, ($this$remember) => {
    var lines = $this$remember.baj(allItems);
    var draws = $this$remember.baj(_this__u8e3s4.hgt());
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = lines.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp_0;
      if (!(element.mfy() == null)) {
        tmp_0 = element.hf9_1.f6l_1;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s_0 = draws.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (element_0.s6v_1.equals(element.kf9_1) && (element_0.b6w_1 || element_0.z6v_1 === true)) {
            destination.v(element_0);
          }
        }
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum_0 = Companion_instance.p91(0n);
        var _iterator__ex2g4s_1 = destination.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          var tmp_1 = sum_0;
          var tmp$ret$66 = element_1.t6v_1;
          sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$66);
        }
        tmp_0 = sum_0;
      }
      var tmp$ret$68 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$68);
    }
    var tmp$ret$69 = sum;
    return new (MonetaryValue())(tmp$ret$69);
  });
  var tmp_18 = view_8.ibb(weight(view_8, weights.shx_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.ebb(p_10, view_10);
  view_10.jba(view_10.ob6_1.ybe(BodySemantic_getInstance()));
  view_10.bbs(Align_Center_getInstance());
  var tmp_19 = KMutableProperty0();
  var tmp_20 = TextView$_get_content_$ref_4pzcwl_0(view_10);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_19, tmp_20, TextView$_set_content_$ref_pketfb_0(view_10));
  reactiveScope(view_10, ($this$reactiveScope) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$reactiveScope.baj(allItems);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$70 = element.hf9_1.f6l_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$70);
    }
    var price = sum;
    var tmp$ret$72 = renderPercent(percentComplete($this$reactiveScope.baj(paid).a5s_1, price), 0);
    this_2.set(tmp$ret$72);
    return Unit_instance;
  });
  view_8.fbb(p_10, view_10);
  view_8.jbb(tmp_18, view_10);
  var tmp_21 = view_8.ibb(weight(view_8, weights.thx_1), get_centered(view_8));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_11 = view_8.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_8 : tmp0_elvis_lhs_11;
  view_8.ebb(p_11, view_11);
  view_11.jba(view_11.ob6_1.ybe(BodySemantic_getInstance()));
  var status = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(scope).p7z_1 ? $this$remember.baj(example).kfy() : null);
  dynamicTheme(view_11, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = $this$dynamicTheme.baj(status);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = LineItemStateSemantic(tmp0_safe_receiver);
    }
    return tmp;
  });
  view_11.bbs(Align_Center_getInstance());
  var tmp_22 = KMutableProperty0();
  var tmp_23 = TextView$_get_content_$ref_4pzcwl_1(view_11);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_22, tmp_23, TextView$_set_content_$ref_pketfb_1(view_11));
  reactiveScope(view_11, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.baj(status);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9b_1;
    var tmp$ret$81 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_3.set(tmp$ret$81);
    return Unit_instance;
  });
  view_8.fbb(p_11, view_11);
  view_8.jbb(tmp_21, view_11);
  var tmp_24 = weight(view_8, weights.uhx_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (Frame())(view_8.pc());
  var tmp0_elvis_lhs_12 = view_8.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_8 : tmp0_elvis_lhs_12;
  view_8.ebb(p_12, view_12);
  var tmp_25 = view_12.ibb(shownWhen(view_12, VOID, ($this$shownWhen) => $this$shownWhen.baj(scope).p7z_1), get_centered(view_12));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_12.pc());
  var tmp0_elvis_lhs_13 = view_12.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
  view_12.ebb(p_13, view_13);
  view_13.xbm(false);
  var tmp_26 = get_centered(view_13);
  view_13.jbb(tmp_26, escalationIcon(view_13, remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.baj(_this__u8e3s4.mgf()).p3($this$remember.baj(example).kf9_1);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n8w();
  })));
  view_13.jbb(get_centered(view_13), timerRunningIcon(_this__u8e3s4, view_13, example));
  view_12.fbb(p_13, view_13);
  view_12.jbb(tmp_25, view_13);
  view_8.fbb(p_12, view_12);
  view_8.jbb(tmp_24, view_12);
  view_5.fbb(p_8, view_8);
  view_5.jbb(tmp_14, view_8);
  view_4.fbb(p_5, view_5);
  view_4.mbg(expandAndMarkAsReadAction(view_4, expand, scopeUnread));
  view_1.fbb(p_4, view_4);
  view_1.jbb(tmp_6, view_4);
  $this$outer.fbb(p_1, view_1);
  $this$outer.jbb(tmp_1, view_1);
  if (_this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance())) {
    var tmp_27 = shownWhen($this$outer, VOID, ($this$shownWhen) => $this$shownWhen.baj(expand) && $this$shownWhen.baj(isManager));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_14 = new (RowOrCol())($this$outer.pc());
    var tmp0_elvis_lhs_14 = $this$outer.cbb_1;
    var p_14 = tmp0_elvis_lhs_14 == null ? $this$outer : tmp0_elvis_lhs_14;
    $this$outer.ebb(p_14, view_14);
    view_14.xbm(false);
    view_14.zb8(get_dp(2));
    var tmp_28 = view_14.ibb(get_centered(view_14), get_textButton(view_14));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_15 = new (Button())(view_14.pc());
    var tmp0_elvis_lhs_15 = view_14.cbb_1;
    var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
    view_14.ebb(p_15, view_15);
    var tmp_29 = KMutableProperty0();
    var tmp_30 = Button$_get_enabled_$ref_61t7nx(view_15);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_4 = getPropertyCallableRef('enabled', 0, tmp_29, tmp_30, Button$_set_enabled_$ref_o8kynz(view_15));
    reactiveScope(view_15, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$111 = !$this$reactiveScope.baj(thisScopesItems).i1();
      this_4.set(tmp$ret$111);
      return Unit_instance;
    });
    body(view_15, '+ Group');
    onClick(view_15, VOID, VOID, renderScopeViewWide$slambda_2(thisScopesItems, scope));
    view_14.fbb(p_15, view_15);
    view_14.jbb(tmp_28, view_15);
    var tmp_31 = get_centered(view_14);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$116 = view_14.hbb(ButtonSemantic_getInstance());
    var tmp_32 = view_14.ibb(tmp_31, tmp$ret$116);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_16 = new (Button())(view_14.pc());
    var tmp0_elvis_lhs_16 = view_14.cbb_1;
    var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
    view_14.ebb(p_16, view_16);
    icon(view_16, resize(get_edit(Companion_getInstance_0()), get_rem_0(1.2)), 'Edit Scope');
    onClick(view_16, VOID, VOID, renderScopeViewWide$slambda_4(scope, _this__u8e3s4));
    view_14.fbb(p_16, view_16);
    view_14.jbb(tmp_32, view_16);
    var tmp_33 = view_14.ibb(get_centered(view_14), get_deleteButton(view_14));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_17 = new (Button())(view_14.pc());
    var tmp0_elvis_lhs_17 = view_14.cbb_1;
    var p_17 = tmp0_elvis_lhs_17 == null ? view_14 : tmp0_elvis_lhs_17;
    view_14.ebb(p_17, view_17);
    icon(view_17, resize(get_trash(Companion_getInstance_0()), get_rem_0(1.2)), 'Remove Scope');
    onClick(view_17, VOID, VOID, renderScopeViewWide$slambda_6(view_17, scope));
    view_14.fbb(p_17, view_17);
    view_14.jbb(tmp_33, view_17);
    $this$outer.fbb(p_14, view_14);
    $this$outer.jbb(tmp_27, view_14);
  }
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  var tmp_34 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expand));
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var indent = Indent_HalfSection_getInstance();
  var tmp2 = indent.ygq_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = indent.zgq_1;
  var tmp_35 = get_unpadded(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_18 = view.cbb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view : tmp0_elvis_lhs_18;
  view.ebb(p_18, view_18);
  var tmp_36;
  var tmp_37 = null;
  if (!((tmp_37 == null ? null : new (Dimension())(tmp_37)) == null)) {
    tmp_36 = sizeConstraints(view_18, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_36 = Companion_getInstance();
  }
  var tmp_38 = view_18.ibb(tmp_36, indented(view_18, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_19 = new (RowOrCol())(view_18.pc());
  var tmp0_elvis_lhs_19 = view_18.cbb_1;
  var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
  view_18.ebb(p_19, view_19);
  view_19.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_20 = new (Space())(view_19.pc(), 0.2);
  var tmp0_elvis_lhs_20 = view_19.cbb_1;
  var p_20 = tmp0_elvis_lhs_20 == null ? view_19 : tmp0_elvis_lhs_20;
  view_19.ebb(p_20, view_20);
  view_19.fbb(p_20, view_20);
  var pendingPayApp = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.baj(allItems);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$134 = item.kf9_1;
      destination.v(tmp$ret$134);
    }
    var ids = destination;
    var tmp0 = $this$remember.baj(_this__u8e3s4.hgt());
    var tmp$ret$137;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$137 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = tmp0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element = _iterator__ex2g4s_0.o1();
        if (ids.t1(element.s6v_1) && element.b6w_1) {
          tmp$ret$137 = true;
          break $l$block_0;
        }
      }
      tmp$ret$137 = false;
    }
    return tmp$ret$137;
  });
  var pendingChange = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.baj(allItems);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$139 = item.kf9_1;
      destination.v(tmp$ret$139);
    }
    var ids = destination;
    var tmp0 = $this$remember.baj(_this__u8e3s4.igt());
    var tmp$ret$142;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$142 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_0 = tmp0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element = _iterator__ex2g4s_0.o1();
        if (ids.t1(element.f72_1) && get_pending(element)) {
          tmp$ret$142 = true;
          break $l$block_2;
        }
      }
      tmp$ret$142 = false;
    }
    return tmp$ret$142;
  });
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (TextView())(view_19.pc());
  var tmp0_elvis_lhs_21 = view_19.cbb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_19 : tmp0_elvis_lhs_21;
  view_19.ebb(p_21, view_21);
  view_21.jba(view_21.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_39 = KMutableProperty0();
  var tmp_40 = TextView$_get_shown_$ref_kipsub(view_21);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('shown', 0, tmp_39, tmp_40, TextView$_set_shown_$ref_l7jsq9(view_21));
  reactiveScope(view_21, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.isNullOrBlank' call
    var this_0 = $this$reactiveScope.baj(scope).n7z_1;
    var tmp$ret$145 = !(this_0 == null || isBlank(this_0));
    this_5.set(tmp$ret$145);
    return Unit_instance;
  });
  var tmp_41 = KMutableProperty0();
  var tmp_42 = TextView$_get_content_$ref_4pzcwl_2(view_21);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_6 = getPropertyCallableRef('content', 0, tmp_41, tmp_42, TextView$_set_content_$ref_pketfb_2(view_21));
  reactiveScope(view_21, ($this$reactiveScope) => {
    var tmp$ret$147 = 'Description: ' + $this$reactiveScope.baj(scope).n7z_1;
    this_6.set(tmp$ret$147);
    return Unit_instance;
  });
  view_19.fbb(p_21, view_21);
  var tmp_43 = shownWhen(view_19, VOID, ($this$shownWhen) => $this$shownWhen.baj(scope).p7z_1);
  var tmp_44 = _this__u8e3s4.jfy();
  view_19.jbb(tmp_43, lineItemBanners(_this__u8e3s4, view_19, example, tmp_44, remember(VOID, VOID, VOID, ($this$remember) => {
    var line = $this$remember.baj(example).kf9_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.bgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.a6h_1.equals(line)) {
        destination.v(element);
      }
    }
    return destination;
  }), pendingPayApp, pendingChange, _this__u8e3s4.rgj(), scope));
  scopeViewRetryWarningBanner(view_19, scope, allItems, _this__u8e3s4.rgj());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_22 = new (RowOrCol())(view_19.pc());
  var tmp0_elvis_lhs_22 = view_19.cbb_1;
  var p_22 = tmp0_elvis_lhs_22 == null ? view_19 : tmp0_elvis_lhs_22;
  view_19.ebb(p_22, view_22);
  view_22.xbm(true);
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(scope.qah());
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
  var scopeGroupId = tmp2_elvis_lhs == null ? Companion_getInstance_1().m2p().toString() : tmp2_elvis_lhs;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_23 = new (RowOrCol())(view_22.pc());
  var tmp0_elvis_lhs_23 = view_22.cbb_1;
  var p_23 = tmp0_elvis_lhs_23 == null ? view_22 : tmp0_elvis_lhs_23;
  view_22.ebb(p_23, view_23);
  view_23.xbm(true);
  view_23.zb8(get_px(0));
  workItemTableHeader(view_23, false, !(dragData == null));
  greySeparator(view_23);
  workItemTableSummary(_this__u8e3s4, allItems, scope, !(dragData == null), view_23);
  greySeparator(view_23);
  renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems_h2uuow(view_23, dragData, _this__u8e3s4, expand, thisScopesItems, scopeGroupId);
  view_22.fbb(p_23, view_23);
  var tmp_45 = view_22.ibb(shownWhen(view_22, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(subscopes).i1();
  }), view_22.hbb(GroupedInformationSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_24 = new (RowOrCol())(view_22.pc());
  var tmp0_elvis_lhs_24 = view_22.cbb_1;
  var p_24 = tmp0_elvis_lhs_24 == null ? view_22 : tmp0_elvis_lhs_24;
  view_22.ebb(p_24, view_24);
  view_24.xbm(true);
  var tmp_46 = scopeGroupId + '-subscopes';
  var tmp_47 = renderScopeViewWide$slambda_8(subscopes);
  var tmp_48 = !(dragData == null);
  forEachMaybeReorderable(view_24, subscopes, tmp_46, tmp_47, tmp_48, VOID, ($this$forEachMaybeReorderable, sub, dragData_0) => {
    var items = remember(VOID, VOID, VOID, ($this$remember) => {
      var id = $this$remember.baj(sub).k7z_1;
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(allItems);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (equals(element.nfy(), id)) {
          destination.v(element);
        }
      }
      return destination;
    });
    var expanded = Signal().fak(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachMaybeReorderable.pc());
    var tmp0_elvis_lhs = $this$forEachMaybeReorderable.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderable : tmp0_elvis_lhs;
    $this$forEachMaybeReorderable.ebb(p, view);
    view.xbm(true);
    view.zb8(get_px(0));
    var tmp = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(2.5));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    var $this$row = view_0;
    $this$row.zb8(get_px(0));
    dynamicTheme($this$row, ($this$dynamicTheme) => $this$dynamicTheme.baj(expanded) ? get_withoutPadding(SectionSemantic_getInstance()) : get_withoutPadding(LightSection_getInstance()));
    if (!(dragData_0 == null)) {
      var tmp_0 = get_centered($this$row);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (IconView())($this$row.pc());
      var tmp0_elvis_lhs_1 = $this$row.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
      $this$row.ebb(p_1, view_1);
      var tmp0_vertical = get_px(0);
      var tmp1_horizontal = div(view_1.kba().hb0_1, 2);
      view_1.hba(Edges().cd0(tmp1_horizontal, tmp0_vertical));
      view_1.ebu('drag');
      view_1.qbt(get_dragHandle(Companion_getInstance_0()));
      var tmp_1 = KMutableProperty0();
      var tmp_2 = IconView$_get_dragData_$ref_4jg2ny_0(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('dragData', 0, tmp_1, tmp_2, IconView$_set_dragData_$ref_k36t82_0(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        var tmp$ret$165 = $this$reactiveScope.baj(dragData_0).fcy(VOID, VOID, DragShadow($this$row, Align_Start_getInstance(), Align_Start_getInstance()));
        this_0.set(tmp$ret$165);
        return Unit_instance;
      });
      $this$row.fbb(p_1, view_1);
      $this$row.jbb(tmp_0, view_1);
    }
    var tmp_3 = get_expanding($this$row);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())($this$row.pc());
    var tmp0_elvis_lhs_2 = $this$row.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
    $this$row.ebb(p_2, view_2);
    view_2.xbm(false);
    view_2.zb8(weights.vhx_1);
    // Inline function 'kotlin.run' call
    var $this$run = weights;
    var tmp$ret$171 = $this$run.qhx_1 + $this$run.rhx_1 + $this$run.shx_1;
    var tmp_4 = view_2.ibb(view_2.ibb(weight(view_2, tmp$ret$171), get_unpadded(view_2)), get_expandButtonTheme(view_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.ebb(p_3, view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.xbm(false);
    view_4.zb8(weights.vhx_1);
    var tmp_5 = view_4.ibb(weight(view_4, weights.qhx_1), get_compact(view_4));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.ebb(p_5, view_5);
    view_5.xbm(false);
    view_5.jbb(get_centered(view_5), expandIcon(view_5, expanded));
    var tmp_6 = view_5.ibb(get_centered(view_5), get_expanding(view_5));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (TextView())(view_5.pc());
    var tmp0_elvis_lhs_6 = view_5.cbb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
    view_5.ebb(p_6, view_6);
    view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextView$_get_content_$ref_4pzcwl_3(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_3(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var tmp$ret$172 = $this$reactiveScope.baj(sub).m7z_1;
      this_1.set(tmp$ret$172);
      return Unit_instance;
    });
    view_5.fbb(p_6, view_6);
    view_5.jbb(tmp_6, view_6);
    view_4.fbb(p_5, view_5);
    view_4.jbb(tmp_5, view_5);
    space(view_4, minus(get_AppDimensions().xg1_1, weights.vhx_1));
    var tmp_9 = weight(view_4, weights.rhx_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Frame())(view_4.pc());
    var tmp0_elvis_lhs_7 = view_4.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_4 : tmp0_elvis_lhs_7;
    view_4.ebb(p_7, view_7);
    var tmp_10 = get_centered(view_7);
    var tmp_11 = ($this$priceWithChange) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$priceWithChange.baj(items);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp$ret$183 = element.v91();
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$183);
      }
      var tmp$ret$184 = sum;
      return new (MonetaryValue())(tmp$ret$184);
    };
    view_7.jbb(tmp_10, priceWithChange(view_7, VOID, tmp_11, ($this$priceWithChange) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$priceWithChange.baj(items);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp$ret$185 = MonetaryValue__minus_impl_jw9qyp(element.v91(), element.hf9_1.n6k_1);
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$185);
      }
      var tmp$ret$186 = sum;
      return new (MonetaryValue())(tmp$ret$186);
    }));
    view_4.fbb(p_7, view_7);
    view_4.jbb(tmp_9, view_7);
    var tmp_12 = view_4.ibb(weight(view_4, weights.shx_1), get_centered(view_4));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (TextView())(view_4.pc());
    var tmp0_elvis_lhs_8 = view_4.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
    view_4.ebb(p_8, view_8);
    view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
    view_8.bbs(Align_Center_getInstance());
    var tmp_13 = KMutableProperty0();
    var tmp_14 = TextView$_get_content_$ref_4pzcwl_4(view_8);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_4(view_8));
    reactiveScope(view_8, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$reactiveScope.baj(items);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$190 = !(item.mfy() == null) ? 1.0 : percentComplete(item.ofy(), item.v91());
        destination.v(tmp$ret$190);
      }
      var completions = destination;
      var tmp$ret$193 = renderPercent(average(completions), 0);
      this_2.set(tmp$ret$193);
      return Unit_instance;
    });
    view_4.fbb(p_8, view_8);
    view_4.jbb(tmp_12, view_8);
    view_3.fbb(p_4, view_4);
    view_3.mbg(expandAction(expanded));
    view_2.fbb(p_3, view_3);
    view_2.jbb(tmp_4, view_3);
    var tmp_15 = weight(view_2, weights.thx_1 + weights.uhx_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (Frame())(view_2.pc());
    var tmp0_elvis_lhs_9 = view_2.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_2 : tmp0_elvis_lhs_9;
    view_2.ebb(p_9, view_9);
    var tmp_16 = view_9.ibb(view_9.ibb(shownWhen(view_9, VOID, ($this$shownWhen) => _this__u8e3s4.rgj().equals(ProjectLens_Contractor_getInstance()) && $this$shownWhen.baj(isManager)), align(view_9, Align_End_getInstance(), Align_Center_getInstance())), get_compact(view_9));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (RowOrCol())(view_9.pc());
    var tmp0_elvis_lhs_10 = view_9.cbb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
    view_9.ebb(p_10, view_10);
    view_10.xbm(false);
    var tmp_17 = get_centered(view_10);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$207 = view_10.hbb(ButtonSemantic_getInstance());
    var tmp_18 = view_10.ibb(tmp_17, tmp$ret$207);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (Button())(view_10.pc());
    var tmp0_elvis_lhs_11 = view_10.cbb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
    view_10.ebb(p_11, view_11);
    icon(view_11, resize(get_edit(Companion_getInstance_0()), get_rem(1)), 'Edit Scope');
    onClick(view_11, VOID, VOID, renderScopeViewWide$lambda$slambda_0(thisScopesItems, items, sub, scope));
    view_10.fbb(p_11, view_11);
    view_10.jbb(tmp_18, view_11);
    var tmp_19 = view_10.ibb(get_centered(view_10), get_deleteButton(view_10));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (Button())(view_10.pc());
    var tmp0_elvis_lhs_12 = view_10.cbb_1;
    var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
    view_10.ebb(p_12, view_12);
    icon(view_12, resize(get_trash(Companion_getInstance_0()), get_rem(1)), 'Remove Scope');
    onClick(view_12, VOID, VOID, renderScopeViewWide$lambda$slambda_2(view_12, sub));
    view_10.fbb(p_12, view_12);
    view_10.jbb(tmp_19, view_12);
    view_9.fbb(p_10, view_10);
    view_9.jbb(tmp_16, view_10);
    view_2.fbb(p_9, view_9);
    view_2.jbb(tmp_15, view_9);
    $this$row.fbb(p_2, view_2);
    $this$row.jbb(tmp_3, view_2);
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_20 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expanded));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_13 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_13 = view.cbb_1;
    var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
    view.ebb(p_13, view_13);
    view_13.xbm(true);
    view_13.zb8(get_px(0));
    var tmp_21 = shownWhen(view_13, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = $this$shownWhen.baj(sub).n7z_1;
      return !(this_0 == null || isBlank(this_0));
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_14 = new (Frame())(view_13.pc());
    var tmp0_elvis_lhs_14 = view_13.cbb_1;
    var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
    view_13.ebb(p_14, view_14);
    var tmp0_vertical_0 = view_14.kba().hb0_1;
    var tmp1_horizontal_0 = get_AppDimensions().xg1_1;
    view_14.hba(Edges().cd0(tmp1_horizontal_0, tmp0_vertical_0).gd0(VOID, VOID, get_px(0)));
    keyString(view_14, 'Description', ($this$keyString) => {
      var tmp0_elvis_lhs = $this$keyString.baj(sub).n7z_1;
      return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    });
    view_13.fbb(p_14, view_14);
    view_13.jbb(tmp_21, view_14);
    var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(sub.qah());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1;
    renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems_h2uuow(view_13, dragData, _this__u8e3s4, expand, items, scopeGroupId + '-' + (tmp1_elvis_lhs == null ? Companion_getInstance_1().m2p() : tmp1_elvis_lhs).toString(), expanded);
    view.fbb(p_13, view_13);
    view.jbb(tmp_20, view_13);
    $this$forEachMaybeReorderable.fbb(p, view);
    return view;
  });
  view_22.fbb(p_24, view_24);
  view_22.jbb(tmp_45, view_24);
  view_19.fbb(p_22, view_22);
  view_19.jbb(get_darkSection(view_19), scopeSetActionBar(_this__u8e3s4, _this__u8e3s4.rgj(), scope, allItems, pendingPayApp, view_19));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_25 = new (Space())(view_19.pc(), 0.5);
  var tmp0_elvis_lhs_25 = view_19.cbb_1;
  var p_25 = tmp0_elvis_lhs_25 == null ? view_19 : tmp0_elvis_lhs_25;
  view_19.ebb(p_25, view_25);
  view_19.fbb(p_25, view_25);
  view_18.fbb(p_19, view_19);
  view_18.jbb(tmp_38, view_19);
  view.fbb(p_18, view_18);
  var tmp$ret$260 = view.jbb(tmp_35, view_18);
  view.jbb(tmp_34, tmp$ret$260);
  greySeparator(view, ($this$greySeparator) => {
    var tmp = KMutableProperty0();
    var tmp_0 = Separator$_get_shown_$ref_e9a0og($this$greySeparator);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Separator$_set_shown_$ref_f1kfq4($this$greySeparator));
    reactiveScope($this$greySeparator, ($this$reactiveScope) => {
      var tmp$ret$261 = !$this$reactiveScope.baj(expand);
      this_0.set(tmp$ret$261);
      return Unit_instance;
    });
    return Unit_instance;
  });
  writer.fbb(p, view);
  return view;
}
function scopeViewRetryWarningBanner(_this__u8e3s4, scopeSet, allItems, lens) {
  var tmp = _this__u8e3s4.ibb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var items = $this$shownWhen.baj(allItems);
    var tmp;
    var tmp_0;
    var tmp_1;
    if ($this$shownWhen.baj(scopeSet).p7z_1) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_1 = !items.i1();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(items, 10));
      var _iterator__ex2g4s = items.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$1 = item.kfy();
        destination.v(tmp$ret$1);
      }
      tmp_0 = distinct(destination).p1() > 1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.minOf' call
      var iterator = items.m1();
      if (!iterator.n1())
        throw NoSuchElementException().y1();
      var minValue = iterator.o1().kfy();
      while (iterator.n1()) {
        var v = iterator.o1().kfy();
        if (compareTo(minValue, v) > 0) {
          minValue = v;
        }
      }
      switch (minValue.b4_1) {
        case 0:
        case 1:
        case 2:
          tmp = lens.equals(ProjectLens_Contractor_getInstance());
          break;
        case 3:
        case 4:
          tmp = lens.xgj();
          break;
        default:
          tmp = false;
          break;
      }
    } else {
      tmp = false;
    }
    return tmp;
  }), notificationBar(_this__u8e3s4, AppColors_getInstance().hfz_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp_0 = get_compact(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.jbb(get_centered(view_0), icon(view_0, resize(Companion_getInstance_0().qcg_1, get_rem_0(1.2)), 'warning'));
  view_0.jbb(get_centered(view_0), bodyBold(view_0, 'We Got Interrupted'));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  body(view, 'We encountered an interruption during your most recent action, so it was only partially sucessful. Please make sure you have a stable internet connection and try agin.');
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
function deleteScopeConfirmation(_this__u8e3s4, scope) {
  var kind = !(scope.q7z_1 == null) ? 'group' : scope.p7z_1 ? 'set' : 'view';
  var tmp = 'Remove Scope ' + titleCase(kind);
  var tmp_0 = 'You are about to remove this scope ' + kind + '. Items will display again as single work items. Are you sure?';
  var tmp_1 = 'Remove ' + titleCase(kind);
  var tmp_2 = DangerButtonSemantic_getInstance();
  confirmationDialog(_this__u8e3s4, tmp, tmp_0, tmp_1, VOID, tmp_2, VOID, VOID, VOID, VOID, deleteScopeConfirmation$slambda_0(scope));
}
function scopeSetActionBar(_this__u8e3s4, lens, scope, items, pendingPayApp, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  view.xbm(false);
  view.zb8(div(get_AppDimensions().xg1_1, 2));
  var actions = scopeSetActions(_this__u8e3s4, view, lens, scope, items);
  var tmp = KMutableProperty0();
  var tmp_0 = RowOrCol$_get_shown_$ref_m8lfse(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, RowOrCol$_set_shown_$ref_7290m6(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    if ($this$reactiveScope.baj(scope).p7z_1) {
      var tmp0 = actions;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.i1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!($this$reactiveScope.baj(element) == null)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    var tmp$ret$2 = tmp;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  var tmp_1 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Space())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view.fbb(p_0, view_0);
  view.jbb(tmp_1, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(false);
  var _iterator__ex2g4s = reversed(withIndex(actions)).m1();
  while (_iterator__ex2g4s.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.o1();
    var idx = _destruct__k2r9zo.cf();
    var action = _destruct__k2r9zo.df();
    if (idx === 0 && lens.equals(ProjectLens_Contractor_getInstance())) {
      var tmp_2 = get_centered(view_1);
      view_1.jbb(view_1.ibb(tmp_2, shownWhen(view_1, false, ($this$shownWhen) => $this$shownWhen.baj(pendingPayApp))), infoBubble(view_1, 'Unavailable \u2014 scope is in a draw under review. Void or wait to enable sign-off.'));
      var tmp_3 = get_centered(view_1);
      view_1.jbb(view_1.ibb(tmp_3, shownWhen(view_1, false, ($this$shownWhen) => {
        var tmp = $this$shownWhen.baj(_this__u8e3s4.sh2());
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_0 = $this$shownWhen.baj(items);
        var sum = Companion_instance.p91(0n);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp_0 = sum;
          var tmp$ret$7 = element.hf9_1.o91();
          sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$7);
        }
        var tmp$ret$8 = sum;
        return MonetaryValue__compareTo_impl_w7ul1r(tmp.a5s_1, tmp$ret$8) < 0;
      })), infoBubble(view_1, 'Unavailable \u2014 remaining scope value is greater than escrow balance. Contact client to deposit more funds to request sign-off.'));
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.ebb(p_2, view_2);
    applyReactiveActionFormatting(view_2, action);
    view_1.fbb(p_2, view_2);
  }
  view.fbb(p_1, view_1);
  writer.fbb(p, view);
  return view;
}
function scopeSetActions(_this__u8e3s4, writer, lens, scope, items) {
  // Inline function 'kotlin.with' call
  var $this$with = writer;
  var itemMessages = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0 = $this$remember.baj(items);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = tmp0.m1();
      if (!iterator.n1()) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      var minElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$0 = minElem;
        break $l$block_0;
      }
      var minValue = minElem.kfy();
      do {
        var e = iterator.o1();
        var v = e.kfy();
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$0 = minElem;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var exampleItem = tmp;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = $this$remember.baj(_this__u8e3s4.bgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.a6h_1.equals(exampleItem.kf9_1)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var primary = remember(VOID, VOID, VOID, ($this$remember) => {
    var scopeSet = $this$remember.baj(scope);
    var tmp;
    if (!scopeSet.p7z_1) {
      return null;
    }
    var project = $this$remember.baj(_this__u8e3s4.jfy());
    var scopeItems = $this$remember.baj(items);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(scopeItems, 10));
    var _iterator__ex2g4s = scopeItems.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$6 = item.kf9_1;
      destination.v(tmp$ret$6);
    }
    var lineIds = destination;
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = scopeItems.m1();
      if (!iterator.n1()) {
        tmp$ret$9 = null;
        break $l$block_2;
      }
      var minElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$9 = minElem;
        break $l$block_2;
      }
      var minValue = minElem.kfy();
      do {
        var e = iterator.o1();
        var v = e.kfy();
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$9 = minElem;
    }
    var tmp0_elvis_lhs = tmp$ret$9;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var lineItem = tmp_0;
    var isCustomer = !lens.equals(ProjectLens_Contractor_getInstance());
    var isContractor = lens.equals(ProjectLens_Contractor_getInstance());
    var tmp1_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j8c_1;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = tmp2_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
    }
    var tmp3_elvis_lhs = tmp_1;
    var isManager = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
    var notComplete = lineItem.kfy().d4(LineItemState_Complete_getInstance()) < 0;
    var started = !(lineItem.lfy() == null);
    var notOnHold = !lineItem.kfy().equals(LineItemState_OnHold_getInstance());
    var tmp4_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var permissions = new (CompletionFlowPermissions())(lineItem.hf9_1, isCustomer, tmp4_safe_receiver == null ? null : tmp4_safe_receiver.j8c_1, $this$remember.baj(itemMessages));
    var tmp_2;
    if (isContractor && isManager && notComplete && !started && setOf([ProjectState_PendingStart_getInstance(), ProjectState_InProgress_getInstance()]).t1(project.w7b_1)) {
      tmp_2 = ButtonAction().dg1('Start Work', VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda_0(project, $this$with, lineItem, _this__u8e3s4, $this$remember, scopeSet));
    } else {
      if (isContractor && isManager && notComplete && setOf([ProjectState_InProgress_getInstance(), ProjectState_PreSubstantialCompletion_getInstance()]).t1(project.w7b_1) && setOf([LineItemState_InProgress_getInstance(), LineItemState_WorkingOnRemedy_getInstance()]).t1(lineItem.kfy())) {
        var tmp_3 = ($this$ButtonAction) => {
          var tmp;
          var tmp0 = $this$ButtonAction.baj(_this__u8e3s4.hgt());
          var tmp$ret$14;
          $l$block_4: {
            // Inline function 'kotlin.collections.none' call
            var tmp_0;
            if (isInterface(tmp0, Collection())) {
              tmp_0 = tmp0.i1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$14 = true;
              break $l$block_4;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (lineIds.t1(element.s6v_1) && element.b6w_1) {
                tmp$ret$14 = false;
                break $l$block_4;
              }
            }
            tmp$ret$14 = true;
          }
          if (tmp$ret$14) {
            // Inline function 'kotlin.collections.filter' call
            var tmp0_0 = $this$ButtonAction.baj(items);
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().w();
            var _iterator__ex2g4s_0 = tmp0_0.m1();
            while (_iterator__ex2g4s_0.n1()) {
              var element_0 = _iterator__ex2g4s_0.o1();
              if (element_0.kfy().equals(lineItem.kfy())) {
                destination.v(element_0);
              }
            }
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s_1 = destination.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var element_1 = _iterator__ex2g4s_1.o1();
              var tmp_1 = sum;
              var tmp$ret$19 = element_1.hf9_1.o91();
              sum = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$19);
            }
            var tmp$ret$20 = sum;
            tmp = MonetaryValue__compareTo_impl_w7ul1r(tmp$ret$20, $this$ButtonAction.baj(_this__u8e3s4.sh2()).a5s_1) <= 0;
          } else {
            tmp = false;
          }
          return tmp;
        };
        tmp_2 = ButtonAction().dg1('Request Sign-Off', VOID, VOID, VOID, VOID, tmp_3, scopeSetActions$lambda$slambda_2($this$remember, _this__u8e3s4, lineItem, items, scopeSet));
      } else {
        var tmp_4;
        if (isCustomer && notComplete && notOnHold) {
          var tmp_5 = permissions.p8y();
          tmp_4 = tmp_5 instanceof RequestComplete();
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp_2 = ButtonAction().dg1('Approve Work', VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda_4(scopeSet, $this$remember, lineItem));
        } else {
          tmp_2 = null;
        }
      }
    }
    return tmp_2;
  });
  var anyUnread = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.baj(items);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$21 = item.kf9_1;
      destination.v(tmp$ret$21);
    }
    var lineIds = destination;
    var tmp = $this$remember.baj(itemMessages);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.baj(_this__u8e3s4.egt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList().w();
    var _iterator__ex2g4s_0 = tmp0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element = _iterator__ex2g4s_0.o1();
      if (lineIds.t1(element.s5d_1)) {
        destination_0.v(element);
      }
    }
    return isUnread(plus(tmp, destination_0), $this$remember.eaj(get_session()).efv_1);
  });
  var secondary = remember(VOID, VOID, VOID, ($this$remember) => {
    var scopeSet = $this$remember.baj(scope);
    var tmp;
    if (!scopeSet.p7z_1) {
      return null;
    }
    var project = $this$remember.baj(_this__u8e3s4.jfy());
    var lineItems = $this$remember.baj(items);
    var tmp$ret$27;
    $l$block_6: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = lineItems.m1();
      if (!iterator.n1()) {
        tmp$ret$27 = null;
        break $l$block_6;
      }
      var minElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$27 = minElem;
        break $l$block_6;
      }
      var minValue = minElem.kfy();
      do {
        var e = iterator.o1();
        var v = e.kfy();
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$27 = minElem;
    }
    var tmp0_elvis_lhs = tmp$ret$27;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var lineItem = tmp_0;
    var isClient = !lens.equals(ProjectLens_Contractor_getInstance());
    var tmp1_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j8c_1;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = tmp2_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
    }
    var tmp3_elvis_lhs = tmp_1;
    var isManager = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
    var notComplete = lineItem.kfy().d4(LineItemState_Complete_getInstance()) < 0;
    var notDisputed = !project.w7b_1.equals(ProjectState_Disputed_getInstance());
    var tmp_2;
    if (!(lineItem.mfy() == null) && (isManager || isClient)) {
      var tmp_3 = Companion_instance_0;
      var tmp_4 = SecondaryButtonSemantic_getInstance();
      var tmp_5 = ($this$withUnread) => $this$withUnread.baj(anyUnread);
      tmp_2 = tmp_3.eg1('View History', tmp_4, VOID, VOID, tmp_5, scopeSetActions$lambda$slambda_6($this$with, lineItem, project, lens, scopeSet, lineItems));
    } else if (isClient && notComplete && notDisputed && lineItem.kfy().equals(LineItemState_RequestingReview_getInstance())) {
      var tmp5_theme = SecondaryButtonSemantic_getInstance();
      var tmp_6 = scopeSetActions$lambda$lambda;
      var tmp_7 = ($this$withActionIcon) => $this$withActionIcon.baj(anyUnread);
      tmp_2 = Companion_instance_0.mg1('Review Request', tmp5_theme, VOID, VOID, tmp_6, tmp_7, scopeSetActions$lambda$slambda_8($this$with, lineItems, lineItem, itemMessages, scope));
    } else if (!isClient && isManager && notComplete && notDisputed && lineItem.kfy().equals(LineItemState_RequestingReview_getInstance())) {
      var tmp_8 = Companion_instance_0;
      var tmp_9 = SecondaryButtonSemantic_getInstance();
      var tmp_10 = ($this$withUnread) => $this$withUnread.baj(anyUnread);
      tmp_2 = tmp_8.eg1('View Request', tmp_9, VOID, VOID, tmp_10, scopeSetActions$lambda$slambda_10($this$with, lineItem, project, lens, scopeSet, lineItems));
    } else {
      tmp_2 = null;
    }
    return tmp_2;
  });
  var tertiary = remember(VOID, VOID, VOID, ($this$remember) => {
    var scopeSet = $this$remember.baj(scope);
    var tmp;
    if (!scopeSet.p7z_1) {
      return null;
    }
    var tmp_0;
    if (!$this$remember.baj(get_selectedApi()).afx_1) {
      return null;
    }
    var scopeItems = $this$remember.baj(items);
    var tmp$ret$32;
    $l$block_8: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = scopeItems.m1();
      if (!iterator.n1()) {
        tmp$ret$32 = null;
        break $l$block_8;
      }
      var minElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$32 = minElem;
        break $l$block_8;
      }
      var minValue = minElem.kfy();
      do {
        var e = iterator.o1();
        var v = e.kfy();
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$32 = minElem;
    }
    var tmp0_elvis_lhs = tmp$ret$32;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var lineItem = tmp_1;
    var isCustomer = !lens.equals(ProjectLens_Contractor_getInstance());
    var notComplete = lineItem.kfy().d4(LineItemState_Complete_getInstance()) < 0;
    var notOnHold = !lineItem.kfy().equals(LineItemState_OnHold_getInstance());
    var tmp1_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
    var permissions = new (CompletionFlowPermissions())(lineItem.hf9_1, isCustomer, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.j8c_1, $this$remember.baj(itemMessages));
    var tmp_2;
    var tmp_3;
    if (isCustomer && notComplete && notOnHold) {
      var tmp_4 = permissions.p8y();
      tmp_3 = tmp_4 instanceof RequestComplete();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = ButtonAction().dg1('Approve Work (BREAKING)', VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda_12(scopeSet, $this$remember, lineItem));
    } else {
      tmp_2 = null;
    }
    return tmp_2;
  });
  var last = remember(VOID, VOID, VOID, ($this$remember) => {
    var scopeSet = $this$remember.baj(scope);
    var tmp;
    if (!scopeSet.p7z_1) {
      return null;
    }
    var tmp_0;
    if (!$this$remember.baj(get_selectedApi()).afx_1) {
      return null;
    }
    var project = $this$remember.baj(_this__u8e3s4.jfy());
    var lineItems = $this$remember.baj(items);
    var tmp$ret$35;
    $l$block_10: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = lineItems.m1();
      if (!iterator.n1()) {
        tmp$ret$35 = null;
        break $l$block_10;
      }
      var minElem = iterator.o1();
      if (!iterator.n1()) {
        tmp$ret$35 = minElem;
        break $l$block_10;
      }
      var minValue = minElem.kfy();
      do {
        var e = iterator.o1();
        var v = e.kfy();
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.n1());
      tmp$ret$35 = minElem;
    }
    var tmp0_elvis_lhs = tmp$ret$35;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var lineItem = tmp_1;
    var isClient = !lens.equals(ProjectLens_Contractor_getInstance());
    var notComplete = lineItem.kfy().d4(LineItemState_Complete_getInstance()) < 0;
    var notDisputed = !project.w7b_1.equals(ProjectState_Disputed_getInstance());
    var tmp_2;
    if (isClient && notComplete && notDisputed && lineItem.kfy().equals(LineItemState_RequestingReview_getInstance())) {
      var tmp2_theme = SecondaryButtonSemantic_getInstance();
      var tmp_3 = scopeSetActions$lambda$lambda_0;
      var tmp_4 = ($this$withActionIcon) => $this$withActionIcon.baj(anyUnread);
      tmp_2 = Companion_instance_0.mg1('Review Request (BREAKING)', tmp2_theme, VOID, VOID, tmp_3, tmp_4, scopeSetActions$lambda$slambda_14($this$with, lineItems, lineItem, itemMessages, scope));
    } else {
      tmp_2 = null;
    }
    return tmp_2;
  });
  return listOf([primary, secondary, tertiary, last]);
}
function renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems_h2uuow(_this__u8e3s4, $dragData, $this_renderScopeViewWide, expand, items, groupId, expandOnJump) {
  expandOnJump = expandOnJump === VOID ? null : expandOnJump;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  var tmp = renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgty_0(items);
  var tmp_0 = !($dragData == null);
  forEachMaybeReorderable(view, items, groupId, tmp, tmp_0, VOID, ($this$forEachMaybeReorderable, item, dragData) => {
    var expandItem = Signal().fak(false);
    var tmp = $this_renderScopeViewWide.xgz();
    var notes = filter(tmp, ($this$filter, it) => equals(it.f5p_1, $this$filter.baj(item).kf9_1));
    var tmp_0 = $this_renderScopeViewWide.ugm();
    var tasks = filter(tmp_0, ($this$filter, it) => equals(it.n7w_1, $this$filter.baj(item).kf9_1));
    var tmp_1 = $this_renderScopeViewWide.bgt();
    var messages = filter(tmp_1, ($this$filter, it) => it.a6h_1.equals($this$filter.baj(item).kf9_1));
    var tmp_2 = get_rawSession();
    var unread = lensUnread(tmp_2, (session) => {
      var tmp = handleOne(session.mfv_1, ($this$handleOne, it) => $this$handleOne.baj(item).hf9_1);
      var tmp_0 = tmp.sfw(session.zfv_1.eft(VOID, ($this$isUnread, it) => $this$isUnread.baj(notes)));
      var tmp_1 = tmp_0.sfw(session.rfv_1.eft(VOID, ($this$isUnread, it) => $this$isUnread.baj(tasks)));
      var tmp_2 = tmp_1.sfw(session.nfv_1.eft(VOID, ($this$isUnread, it) => $this$isUnread.baj(item).jf9_1));
      return tmp_2.sfw(session.mfv_1.ofu(VOID, VOID, ($this$creditsIsUnread) => setOf_0($this$creditsIsUnread.baj(item).hf9_1)));
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachMaybeReorderable.pc());
    var tmp0_elvis_lhs = $this$forEachMaybeReorderable.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderable : tmp0_elvis_lhs;
    $this$forEachMaybeReorderable.ebb(p, view);
    view.xbm(true);
    view.zb8(get_px(0));
    var row = workItemTableRow($this_renderScopeViewWide, expandItem, item, view, unread, VOID, dragData);
    launch(view, VOID, VOID, renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3_0(item, row, expand, expandOnJump, expandItem));
    view.jbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(expandItem)), renderLineItemDetails($this_renderScopeViewWide, item, notes, tasks, messages, expandItem, view));
    greySeparator(view);
    $this$forEachMaybeReorderable.fbb(p, view);
    return view;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function *_generator_scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems__3a7row($this_remember, scopeSet, lineItem, $completion) {
  var session = $this_remember.baj(get_session());
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp_0 = and(eq(get_scopeSet(it), scopeSet.k7z_1), eq(get_state(it), lineItem.kfy()));
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  var tmp_2 = get_started(it_0);
  // Inline function 'com.lightningkite.now' call
  var tmp$ret$7 = get_default(Companion_instance_1).d1m();
  this_0.e44(tmp_2, tmp$ret$7);
  var tmp$ret$11 = this_0.o1r();
  var tmp_3 = session.mfv_1.dek(new (MassModification())(tmp_0, tmp$ret$11), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems_n6ltaw($this_remember, scopeSet, lineItem, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems__3a7row.bind(VOID, $this_remember, scopeSet, lineItem), $completion);
}
function renderScopeViewWide$lambda(it) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.minByOrNull' call
    var iterator = it.m1();
    if (!iterator.n1()) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    var minElem = iterator.o1();
    if (!iterator.n1()) {
      tmp$ret$0 = minElem;
      break $l$block_0;
    }
    var minValue = minElem.kfy();
    do {
      var e = iterator.o1();
      var v = e.kfy();
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.n1());
    tmp$ret$0 = minElem;
  }
  return tmp$ret$0;
}
function renderScopeViewWide$lambda_0($this$remember) {
  var tmp0_safe_receiver = $this$remember.baj($this$remember.baj(get_session()).pfw_1).m88_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp1_safe_receiver.d4(MemberRole_Manager_getInstance()) >= 0;
  }
  var tmp2_elvis_lhs = tmp;
  return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = JumpTo_getInstance().sg3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xhx_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.k7z_1;
  tmp.xg4(tmp_1, $this.yhx_1, VOID, () => {
    $this.zhx_1.mam(true);
    return Unit_instance;
  });
  return Unit_instance;
}
var renderScopeViewWide$slambdaClass;
function renderScopeViewWide$slambda() {
  if (renderScopeViewWide$slambdaClass === VOID) {
    class $ {
      constructor($scope, $$this$outer, $expand) {
        this.xhx_1 = $scope;
        this.yhx_1 = $$this$outer;
        this.zhx_1 = $expand;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderScopeViewWide$slambdaClass = $;
  }
  return renderScopeViewWide$slambdaClass;
}
function renderScopeViewWide$slambda_0($scope, $$this$outer, $expand) {
  var i = new (renderScopeViewWide$slambda())($scope, $$this$outer, $expand);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function IconView$_get_dragData_$ref_4jg2ny(p0) {
  return () => p0.hb9();
}
function IconView$_set_dragData_$ref_k36t82(p0) {
  return (_this__u8e3s4) => {
    p0.gb9(_this__u8e3s4);
    return Unit_instance;
  };
}
function renderScopeViewWide$lambda$lambda(it) {
  return requiresAction(it);
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ahy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return it.e80(VOID, VOID, VOID, tmp$ret$0.k7z_1);
}
function *_generator_invoke__zhh2q8_1($this, draft, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = modify(draft, renderScopeViewWide$slambda$slambda$slambda_0($this.bhy_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = pushChanges(draft, session.ufv_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var scope = tmp_1;
  var tmp_2 = session.tfw().vfg_1.zfq(scope.k7z_1, selected, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var selected_0 = toSet(selected);
  var tmp_3 = (it) => selected_0.t1(it.g6k_1);
  session.mfv_1.ceo(tmp_3, (it) => it.i6l(VOID, VOID, VOID, scope.k7z_1));
  return Unit_instance;
}
var renderScopeViewWide$slambda$slambda$slambdaClass;
function renderScopeViewWide$slambda$slambda$slambda() {
  if (renderScopeViewWide$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($scope) {
        this.ahy_1 = $scope;
      }
      nhp(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.nhp(p1 instanceof ScopeView() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderScopeViewWide$slambda$slambda$slambdaClass = $;
  }
  return renderScopeViewWide$slambda$slambda$slambdaClass;
}
function renderScopeViewWide$slambda$slambda$slambda_0($scope) {
  var i = new (renderScopeViewWide$slambda$slambda$slambda())($scope);
  var l = (it, $completion) => i.nhp(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.chy_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.dhy_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = new (Subscope())(tmp$ret$1);
  tmp.xgd(new (CreateScopeViewDialog())(tmp_1, tmp_3, renderScopeViewWide$slambda$slambda_0($this.dhy_1)));
  return Unit_instance;
}
var renderScopeViewWide$slambda$slambdaClass;
function renderScopeViewWide$slambda$slambda() {
  if (renderScopeViewWide$slambda$slambdaClass === VOID) {
    class $ {
      constructor($scope) {
        this.bhy_1 = $scope;
      }
      shp(draft, selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, draft, selected), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Draft()) : false) ? p1 : THROW_CCE();
        return this.shp(tmp, (!(p2 == null) ? isInterface(p2, KtList()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    renderScopeViewWide$slambda$slambdaClass = $;
  }
  return renderScopeViewWide$slambda$slambdaClass;
}
function renderScopeViewWide$slambda$slambda_0($scope) {
  var i = new (renderScopeViewWide$slambda$slambda())($scope);
  var l = (draft, selected, $completion) => i.shp(draft, selected, $completion);
  l.$arity = 2;
  return l;
}
var renderScopeViewWide$slambdaClass_0;
function renderScopeViewWide$slambda_1() {
  if (renderScopeViewWide$slambdaClass_0 === VOID) {
    class $ {
      constructor($thisScopesItems, $scope) {
        this.chy_1 = $thisScopesItems;
        this.dhy_1 = $scope;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderScopeViewWide$slambdaClass_0 = $;
  }
  return renderScopeViewWide$slambdaClass_0;
}
function renderScopeViewWide$slambda_2($thisScopesItems, $scope) {
  var i = new (renderScopeViewWide$slambda_1())($thisScopesItems, $scope);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ehy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var scope = tmp;
  var tmp_0 = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.fhy_1.tgm();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  var tmp0_safe_receiver = scope.q7z_1;
  var tmp_3;
  if (tmp0_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.fhy_1.lgy();
    var tmp_4 = await_0(this_2, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    // Inline function 'kotlin.collections.find' call
    var tmp0 = tmp_4;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.k7z_1.equals(tmp0_safe_receiver)) {
          tmp$ret$4 = element;
          break $l$block;
        }
      }
      tmp$ret$4 = null;
    }
    tmp_3 = tmp$ret$4;
  }
  tmp_0.xgd(new (EditScopeViewDialog())(tmp_2, scope, tmp_3));
  return Unit_instance;
}
var renderScopeViewWide$slambdaClass_1;
function renderScopeViewWide$slambda_3() {
  if (renderScopeViewWide$slambdaClass_1 === VOID) {
    class $ {
      constructor($scope, $this_renderScopeViewWide) {
        this.ehy_1 = $scope;
        this.fhy_1 = $this_renderScopeViewWide;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderScopeViewWide$slambdaClass_1 = $;
  }
  return renderScopeViewWide$slambdaClass_1;
}
function renderScopeViewWide$slambda_4($scope, $this_renderScopeViewWide) {
  var i = new (renderScopeViewWide$slambda_3())($scope, $this_renderScopeViewWide);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.hhy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  deleteScopeConfirmation($this.ghy_1, tmp$ret$0);
  return Unit_instance;
}
var renderScopeViewWide$slambdaClass_2;
function renderScopeViewWide$slambda_5() {
  if (renderScopeViewWide$slambdaClass_2 === VOID) {
    class $ {
      constructor($$this$button, $scope) {
        this.ghy_1 = $$this$button;
        this.hhy_1 = $scope;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderScopeViewWide$slambdaClass_2 = $;
  }
  return renderScopeViewWide$slambdaClass_2;
}
function renderScopeViewWide$slambda_6($$this$button, $scope) {
  var i = new (renderScopeViewWide$slambda_5())($$this$button, $scope);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.wb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_5($this, move, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ihy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = reorder(move, tmp_0, tmp$ret$1.ufv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var renderScopeViewWide$slambdaClass_3;
function renderScopeViewWide$slambda_7() {
  if (renderScopeViewWide$slambdaClass_3 === VOID) {
    class $ {
      constructor($subscopes) {
        this.ihy_1 = $subscopes;
      }
      dhm(move, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, move), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderScopeViewWide$slambdaClass_3 = $;
  }
  return renderScopeViewWide$slambdaClass_3;
}
function renderScopeViewWide$slambda_8($subscopes) {
  var i = new (renderScopeViewWide$slambda_7())($subscopes);
  var l = (move, $completion) => i.dhm(move, $completion);
  l.$arity = 1;
  return l;
}
function IconView$_get_dragData_$ref_4jg2ny_0(p0) {
  return () => p0.hb9();
}
function IconView$_set_dragData_$ref_k36t82_0(p0) {
  return (_this__u8e3s4) => {
    p0.gb9(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jhy_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.khy_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = plus(tmp_1, tmp$ret$1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.lhy_1;
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.mhy_1;
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp$ret$3 = tmp_6;
  tmp.xgd(new (EditScopeViewDialog())(tmp_3, tmp_5, tmp$ret$3));
  return Unit_instance;
}
var renderScopeViewWide$lambda$slambdaClass;
function renderScopeViewWide$lambda$slambda() {
  if (renderScopeViewWide$lambda$slambdaClass === VOID) {
    class $ {
      constructor($thisScopesItems, $items, $sub, $scope) {
        this.jhy_1 = $thisScopesItems;
        this.khy_1 = $items;
        this.lhy_1 = $sub;
        this.mhy_1 = $scope;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderScopeViewWide$lambda$slambdaClass = $;
  }
  return renderScopeViewWide$lambda$slambdaClass;
}
function renderScopeViewWide$lambda$slambda_0($thisScopesItems, $items, $sub, $scope) {
  var i = new (renderScopeViewWide$lambda$slambda())($thisScopesItems, $items, $sub, $scope);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ohy_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  deleteScopeConfirmation($this.nhy_1, tmp$ret$0);
  return Unit_instance;
}
var renderScopeViewWide$lambda$slambdaClass_0;
function renderScopeViewWide$lambda$slambda_1() {
  if (renderScopeViewWide$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $sub) {
        this.nhy_1 = $$this$button;
        this.ohy_1 = $sub;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderScopeViewWide$lambda$slambdaClass_0 = $;
  }
  return renderScopeViewWide$lambda$slambdaClass_0;
}
function renderScopeViewWide$lambda$slambda_2($$this$button, $sub) {
  var i = new (renderScopeViewWide$lambda$slambda_1())($$this$button, $sub);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Separator$_get_shown_$ref_e9a0og(p0) {
  return () => p0.wb8();
}
function Separator$_set_shown_$ref_f1kfq4(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.ufv_1.kft($this.phy_1.k7z_1).iem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var deleteScopeConfirmation$slambdaClass;
function deleteScopeConfirmation$slambda() {
  if (deleteScopeConfirmation$slambdaClass === VOID) {
    class $ {
      constructor($scope) {
        this.phy_1 = $scope;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    deleteScopeConfirmation$slambdaClass = $;
  }
  return deleteScopeConfirmation$slambdaClass;
}
function deleteScopeConfirmation$slambda_0($scope) {
  var i = new (deleteScopeConfirmation$slambda())($scope);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.wb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems_n6ltaw($this.qhy_1, $this.rhy_1, $this.shy_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $this$async, $completion) {
  var it = $this.thy_1;
  var tmp = $this.uhy_1.tfw().ofg_1.qfo(it.v75_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp;
}
function *_generator_invoke__zhh2q8_11($this, $this$coroutineScope, $completion) {
  // Inline function 'com.crowpay.utils.mapAsync' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.vhy_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, scopeSetActions$lambda$slambda$slambda$slambda$slambda_0(item, $this.why_1));
    destination.v(tmp$ret$0);
  }
  var tmp = awaitAll(destination, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.associateBy' call
  var this_1 = tmp;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = this_1.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp$ret$4 = element.v75_1;
    destination_0.s3(tmp$ret$4, element);
  }
  return destination_0;
}
var scopeSetActions$lambda$slambda$slambda$slambda$slambdaClass;
function scopeSetActions$lambda$slambda$slambda$slambda$slambda() {
  if (scopeSetActions$lambda$slambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it, $session) {
        this.thy_1 = $it;
        this.uhy_1 = $session;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambda$slambda$slambda$slambdaClass = $;
  }
  return scopeSetActions$lambda$slambda$slambda$slambda$slambdaClass;
}
function scopeSetActions$lambda$slambda$slambda$slambda$slambda_0($it, $session) {
  var i = new (scopeSetActions$lambda$slambda$slambda$slambda$slambda())($it, $session);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  var tmp = awaitSuspending(get_session(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = coroutineScope(scopeSetActions$lambda$slambda$slambda$slambda_0($this.ahz_1, session), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var updates = tmp_0;
  var tmp_1 = (it) => updates.q3().t1(it.v75_1);
  session.sfv_1.ceo(tmp_1, (it) => updates.p3(it.v75_1));
  var tmp_2 = scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems_n6ltaw($this.xhy_1, $this.yhy_1, $this.zhy_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var scopeSetActions$lambda$slambda$slambda$slambdaClass;
function scopeSetActions$lambda$slambda$slambda$slambda() {
  if (scopeSetActions$lambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($outstanding, $session) {
        this.vhy_1 = $outstanding;
        this.why_1 = $session;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambda$slambda$slambdaClass = $;
  }
  return scopeSetActions$lambda$slambda$slambda$slambdaClass;
}
function scopeSetActions$lambda$slambda$slambda$slambda_0($outstanding, $session) {
  var i = new (scopeSetActions$lambda$slambda$slambda$slambda())($outstanding, $session);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  var tmp = scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems_n6ltaw($this.bhz_1, $this.chz_1, $this.dhz_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  var tmp = scopeSetActions$_anonymous_$_anonymous_$_anonymous_$startItems_n6ltaw($this.ehz_1, $this.fhz_1, $this.ghz_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $this$ButtonAction, $completion) {
  if ($this.hhz_1.g7c_1 == null) {
    confirmationDialog($this.ihz_1, 'Start Items and Project?', 'Starting this scope will start the project and all items in the scope set', 'Start Items and Project', VOID, VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda$slambda_0($this.lhz_1, $this.mhz_1, $this.jhz_1));
  } else if (!($this.jhz_1.q94() == null)) {
    var tmp = awaitSuspending($this.khz_1.jgt(), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = tmp;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (get_pending(element) && element.x75_1.equals(ensureNotNull($this.jhz_1.q94()).z5a_1)) {
        destination.v(element);
      }
    }
    var outstanding = destination;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!outstanding.i1()) {
      var tmp_0 = 'Starting this scope will start all items in the scope set and cancel the remaining ' + outstanding.p1() + ' pending items in this change.';
      confirmationDialog($this.ihz_1, 'Start Work Items?', tmp_0, 'Start Work Items', VOID, VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda$slambda_2($this.lhz_1, $this.mhz_1, $this.jhz_1, outstanding));
    } else {
      confirmationDialog($this.ihz_1, 'Start Work Items?', 'Starting this scope will start all items in the scope set', 'Start Work Items', VOID, VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda$slambda_4($this.lhz_1, $this.mhz_1, $this.jhz_1));
    }
  } else {
    confirmationDialog($this.ihz_1, 'Start Work Items?', 'Starting this work item will start all items in the scope set', 'Start Work Items', VOID, VOID, VOID, VOID, VOID, VOID, scopeSetActions$lambda$slambda$slambda_6($this.lhz_1, $this.mhz_1, $this.jhz_1));
  }
  return Unit_instance;
}
var scopeSetActions$lambda$slambda$slambdaClass;
function scopeSetActions$lambda$slambda$slambda() {
  if (scopeSetActions$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_remember, $scopeSet, $lineItem) {
        this.qhy_1 = $this_remember;
        this.rhy_1 = $scopeSet;
        this.shy_1 = $lineItem;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    scopeSetActions$lambda$slambda$slambdaClass = $;
  }
  return scopeSetActions$lambda$slambda$slambdaClass;
}
function scopeSetActions$lambda$slambda$slambda_0($this_remember, $scopeSet, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda$slambda())($this_remember, $scopeSet, $lineItem);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var scopeSetActions$lambda$slambda$slambdaClass_0;
function scopeSetActions$lambda$slambda$slambda_1() {
  if (scopeSetActions$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_remember, $scopeSet, $lineItem, $outstanding) {
        this.xhy_1 = $this_remember;
        this.yhy_1 = $scopeSet;
        this.zhy_1 = $lineItem;
        this.ahz_1 = $outstanding;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    scopeSetActions$lambda$slambda$slambdaClass_0 = $;
  }
  return scopeSetActions$lambda$slambda$slambdaClass_0;
}
function scopeSetActions$lambda$slambda$slambda_2($this_remember, $scopeSet, $lineItem, $outstanding) {
  var i = new (scopeSetActions$lambda$slambda$slambda_1())($this_remember, $scopeSet, $lineItem, $outstanding);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var scopeSetActions$lambda$slambda$slambdaClass_1;
function scopeSetActions$lambda$slambda$slambda_3() {
  if (scopeSetActions$lambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($this_remember, $scopeSet, $lineItem) {
        this.bhz_1 = $this_remember;
        this.chz_1 = $scopeSet;
        this.dhz_1 = $lineItem;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    scopeSetActions$lambda$slambda$slambdaClass_1 = $;
  }
  return scopeSetActions$lambda$slambda$slambdaClass_1;
}
function scopeSetActions$lambda$slambda$slambda_4($this_remember, $scopeSet, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda$slambda_3())($this_remember, $scopeSet, $lineItem);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var scopeSetActions$lambda$slambda$slambdaClass_2;
function scopeSetActions$lambda$slambda$slambda_5() {
  if (scopeSetActions$lambda$slambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_remember, $scopeSet, $lineItem) {
        this.ehz_1 = $this_remember;
        this.fhz_1 = $scopeSet;
        this.ghz_1 = $lineItem;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    scopeSetActions$lambda$slambda$slambdaClass_2 = $;
  }
  return scopeSetActions$lambda$slambda$slambdaClass_2;
}
function scopeSetActions$lambda$slambda$slambda_6($this_remember, $scopeSet, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda$slambda_5())($this_remember, $scopeSet, $lineItem);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var scopeSetActions$lambda$slambdaClass;
function scopeSetActions$lambda$slambda() {
  if (scopeSetActions$lambda$slambdaClass === VOID) {
    class $ {
      constructor($project, $$this$with, $lineItem, $this_scopeSetActions, $this_remember, $scopeSet) {
        this.hhz_1 = $project;
        this.ihz_1 = $$this$with;
        this.jhz_1 = $lineItem;
        this.khz_1 = $this_scopeSetActions;
        this.lhz_1 = $this_remember;
        this.mhz_1 = $scopeSet;
      }
      wah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass = $;
  }
  return scopeSetActions$lambda$slambdaClass;
}
function scopeSetActions$lambda$slambda_0($project, $$this$with, $lineItem, $this_scopeSetActions, $this_remember, $scopeSet) {
  var i = new (scopeSetActions$lambda$slambda())($project, $$this$with, $lineItem, $this_scopeSetActions, $this_remember, $scopeSet);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var scopeSetActions$lambda$slambdaClass_0;
function scopeSetActions$lambda$slambda_1() {
  if (scopeSetActions$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_remember, $this_scopeSetActions, $lineItem, $items, $scopeSet) {
        this.nhz_1 = $this_remember;
        this.ohz_1 = $this_scopeSetActions;
        this.phz_1 = $lineItem;
        this.qhz_1 = $items;
        this.rhz_1 = $scopeSet;
      }
      wah($this$ButtonAction, $completion) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.nhz_1.baj(this.ohz_1.ugm());
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (equals(element.n7w_1, this.phz_1.kf9_1)) {
            destination.v(element);
          }
        }
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(destination, Collection())) {
            tmp = destination.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.r7w_1 && element_0.s7w_1 == null) {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          get_dialogStack().xgd(GenericDialog().zgy('You still have required punch list items pending. You cannot request review until all required punch list items are complete.'));
        } else {
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = this.nhz_1.baj(this.qhz_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_1 = tmp0_0.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            if (element_1.kfy().equals(this.phz_1.kfy())) {
              destination_0.v(element_1);
            }
          }
          var lines = destination_0;
          var tmp_0 = get_dialogStack();
          // Inline function 'kotlin.collections.filter' call
          var tmp0_1 = this.nhz_1.baj(this.ohz_1.bgt());
          // Inline function 'kotlin.collections.filterTo' call
          var destination_1 = ArrayList().w();
          var _iterator__ex2g4s_2 = tmp0_1.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            var tmp0_safe_receiver = firstOrNull(lines);
            if (element_2.a6h_1.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kf9_1)) {
              destination_1.v(element_2);
            }
          }
          tmp_0.xgd(WorkItemRequestSignOffDialog(lines, destination_1, this.rhz_1));
        }
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_0 = $;
  }
  return scopeSetActions$lambda$slambdaClass_0;
}
function scopeSetActions$lambda$slambda_2($this_remember, $this_scopeSetActions, $lineItem, $items, $scopeSet) {
  var i = new (scopeSetActions$lambda$slambda_1())($this_remember, $this_scopeSetActions, $lineItem, $items, $scopeSet);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_16($this, item, $completion) {
  var tmp = $this.shz_1.tfw().efg_1.hfm(item.g6k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  var tmp_0 = (it) => it.g6k_1.equals(result.g6k_1);
  $this.shz_1.mfv_1.ceo(tmp_0, (it) => result);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, confirmed, $completion) {
  if (confirmed) {
    var session = $this.thz_1.baj(get_session());
    var tmp = repeatForScopeSets($this.uhz_1, scopeSetActions$lambda$slambda$slambda$slambda_2(session), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var scopeSetActions$lambda$slambda$slambda$slambdaClass_0;
function scopeSetActions$lambda$slambda$slambda$slambda_1() {
  if (scopeSetActions$lambda$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($session) {
        this.shz_1 = $session;
      }
      bgy(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this, item), $completion);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambda$slambda$slambdaClass_0 = $;
  }
  return scopeSetActions$lambda$slambda$slambda$slambdaClass_0;
}
function scopeSetActions$lambda$slambda$slambda$slambda_2($session) {
  var i = new (scopeSetActions$lambda$slambda$slambda$slambda_1())($session);
  var l = (item, $completion) => i.bgy(item, $completion);
  l.$arity = 1;
  return l;
}
var scopeSetActions$lambda$slambda$slambdaClass_3;
function scopeSetActions$lambda$slambda$slambda_7() {
  if (scopeSetActions$lambda$slambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($this_remember, $lineItem) {
        this.thz_1 = $this_remember;
        this.uhz_1 = $lineItem;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambda$slambdaClass_3 = $;
  }
  return scopeSetActions$lambda$slambda$slambdaClass_3;
}
function scopeSetActions$lambda$slambda$slambda_8($this_remember, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda$slambda_7())($this_remember, $lineItem);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var scopeSetActions$lambda$slambdaClass_1;
function scopeSetActions$lambda$slambda_3() {
  if (scopeSetActions$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($scopeSet, $this_remember, $lineItem) {
        this.vhz_1 = $scopeSet;
        this.whz_1 = $this_remember;
        this.xhz_1 = $lineItem;
      }
      wah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = 'Approve & Release ' + this.vhz_1.m7z_1 + '?';
        var tmp_1 = PrimaryButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())(tmp_0, 'Approving this work item releases funds to the contractor as payment.', VOID, 'Approve', VOID, tmp_1, VOID, VOID, VOID, 'SIGN-OFF REVIEW', scopeSetActions$lambda$slambda$slambda_8(this.whz_1, this.xhz_1)));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_1 = $;
  }
  return scopeSetActions$lambda$slambdaClass_1;
}
function scopeSetActions$lambda$slambda_4($scopeSet, $this_remember, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda_3())($scopeSet, $this_remember, $lineItem);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_18($this, $this$withUnread, $completion) {
  var tmp = Companion_instance_2;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var this_0 = $this.di0_1;
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0 = sum;
    var tmp$ret$0 = element.v91();
    sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$0);
  }
  var tmp$ret$1 = sum;
  var tmp_1 = tmp.fht($this.zhz_1, $this.ai0_1, $this.bi0_1, new (ScopeSetInfo())($this.ci0_1.k7z_1, $this.ci0_1.m7z_1, tmp$ret$1), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  navigateOrDialog($this.yhz_1, tmp_1);
  return Unit_instance;
}
var scopeSetActions$lambda$slambdaClass_2;
function scopeSetActions$lambda$slambda_5() {
  if (scopeSetActions$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($$this$with, $lineItem, $project, $lens, $scopeSet, $lineItems) {
        this.yhz_1 = $$this$with;
        this.zhz_1 = $lineItem;
        this.ai0_1 = $project;
        this.bi0_1 = $lens;
        this.ci0_1 = $scopeSet;
        this.di0_1 = $lineItems;
      }
      wah($this$withUnread, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this, $this$withUnread), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_2 = $;
  }
  return scopeSetActions$lambda$slambdaClass_2;
}
function scopeSetActions$lambda$slambda_6($$this$with, $lineItem, $project, $lens, $scopeSet, $lineItems) {
  var i = new (scopeSetActions$lambda$slambda_5())($$this$with, $lineItem, $project, $lens, $scopeSet, $lineItems);
  var l = ($this$withUnread, $completion) => i.wah($this$withUnread, $completion);
  l.$arity = 1;
  return l;
}
function scopeSetActions$lambda$lambda($this$withActionIcon) {
  return ActionImportance_Important_getInstance();
}
function *_generator_invoke__zhh2q8_19($this, $this$withActionIcon, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.fi0_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.kfy().equals($this.gi0_1.kfy())) {
      destination.v(element);
    }
  }
  var tmp = destination;
  var tmp_0 = awaitSuspending($this.hi0_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = awaitSuspending($this.ii0_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  navigateOrDialog($this.ei0_1, new (ScopeSetReviewDialog())(tmp, tmp_0, tmp_1));
  return Unit_instance;
}
var scopeSetActions$lambda$slambdaClass_3;
function scopeSetActions$lambda$slambda_7() {
  if (scopeSetActions$lambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($$this$with, $lineItems, $lineItem, $itemMessages, $scope) {
        this.ei0_1 = $$this$with;
        this.fi0_1 = $lineItems;
        this.gi0_1 = $lineItem;
        this.hi0_1 = $itemMessages;
        this.ii0_1 = $scope;
      }
      wah($this$withActionIcon, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$withActionIcon), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_3 = $;
  }
  return scopeSetActions$lambda$slambdaClass_3;
}
function scopeSetActions$lambda$slambda_8($$this$with, $lineItems, $lineItem, $itemMessages, $scope) {
  var i = new (scopeSetActions$lambda$slambda_7())($$this$with, $lineItems, $lineItem, $itemMessages, $scope);
  var l = ($this$withActionIcon, $completion) => i.wah($this$withActionIcon, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_20($this, $this$withUnread, $completion) {
  var tmp = Companion_instance_2;
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var this_0 = $this.oi0_1;
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0 = sum;
    var tmp$ret$0 = element.v91();
    sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$0);
  }
  var tmp$ret$1 = sum;
  var tmp_1 = tmp.fht($this.ki0_1, $this.li0_1, $this.mi0_1, new (ScopeSetInfo())($this.ni0_1.k7z_1, $this.ni0_1.m7z_1, tmp$ret$1), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  navigateOrDialog($this.ji0_1, tmp_1);
  return Unit_instance;
}
var scopeSetActions$lambda$slambdaClass_4;
function scopeSetActions$lambda$slambda_9() {
  if (scopeSetActions$lambda$slambdaClass_4 === VOID) {
    class $ {
      constructor($$this$with, $lineItem, $project, $lens, $scopeSet, $lineItems) {
        this.ji0_1 = $$this$with;
        this.ki0_1 = $lineItem;
        this.li0_1 = $project;
        this.mi0_1 = $lens;
        this.ni0_1 = $scopeSet;
        this.oi0_1 = $lineItems;
      }
      wah($this$withUnread, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this, $this$withUnread), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_4 = $;
  }
  return scopeSetActions$lambda$slambdaClass_4;
}
function scopeSetActions$lambda$slambda_10($$this$with, $lineItem, $project, $lens, $scopeSet, $lineItems) {
  var i = new (scopeSetActions$lambda$slambda_9())($$this$with, $lineItem, $project, $lens, $scopeSet, $lineItems);
  var l = ($this$withUnread, $completion) => i.wah($this$withUnread, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_21($this, item, $completion) {
  var tmp = $this.pi0_1.tfw().efg_1.hfm(item.g6k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  var tmp_0 = (it) => it.g6k_1.equals(result.g6k_1);
  $this.pi0_1.mfv_1.ceo(tmp_0, (it) => result);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_22($this, confirmed, $completion) {
  if (confirmed) {
    var session = $this.qi0_1.baj(get_session());
    var tmp = repeatForScopeSets_BREAK_FOR_TESTING($this.ri0_1, scopeSetActions$lambda$slambda$slambda$slambda_4(session), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var scopeSetActions$lambda$slambda$slambda$slambdaClass_1;
function scopeSetActions$lambda$slambda$slambda$slambda_3() {
  if (scopeSetActions$lambda$slambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($session) {
        this.pi0_1 = $session;
      }
      bgy(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this, item), $completion);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambda$slambda$slambdaClass_1 = $;
  }
  return scopeSetActions$lambda$slambda$slambda$slambdaClass_1;
}
function scopeSetActions$lambda$slambda$slambda$slambda_4($session) {
  var i = new (scopeSetActions$lambda$slambda$slambda$slambda_3())($session);
  var l = (item, $completion) => i.bgy(item, $completion);
  l.$arity = 1;
  return l;
}
var scopeSetActions$lambda$slambda$slambdaClass_4;
function scopeSetActions$lambda$slambda$slambda_9() {
  if (scopeSetActions$lambda$slambda$slambdaClass_4 === VOID) {
    class $ {
      constructor($this_remember, $lineItem) {
        this.qi0_1 = $this_remember;
        this.ri0_1 = $lineItem;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambda$slambdaClass_4 = $;
  }
  return scopeSetActions$lambda$slambda$slambdaClass_4;
}
function scopeSetActions$lambda$slambda$slambda_10($this_remember, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda$slambda_9())($this_remember, $lineItem);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
var scopeSetActions$lambda$slambdaClass_5;
function scopeSetActions$lambda$slambda_11() {
  if (scopeSetActions$lambda$slambdaClass_5 === VOID) {
    class $ {
      constructor($scopeSet, $this_remember, $lineItem) {
        this.si0_1 = $scopeSet;
        this.ti0_1 = $this_remember;
        this.ui0_1 = $lineItem;
      }
      wah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = 'Approve & Release ' + this.si0_1.m7z_1 + '?';
        var tmp_1 = PrimaryButtonSemantic_getInstance();
        tmp.xgd(new (GenericConfirmationDialog())(tmp_0, 'Approving this work item releases funds to the contractor as payment.', VOID, 'Approve', VOID, tmp_1, VOID, VOID, VOID, 'SIGN-OFF REVIEW', scopeSetActions$lambda$slambda$slambda_10(this.ti0_1, this.ui0_1)));
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_5 = $;
  }
  return scopeSetActions$lambda$slambdaClass_5;
}
function scopeSetActions$lambda$slambda_12($scopeSet, $this_remember, $lineItem) {
  var i = new (scopeSetActions$lambda$slambda_11())($scopeSet, $this_remember, $lineItem);
  var l = ($this$ButtonAction, $completion) => i.wah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function scopeSetActions$lambda$lambda_0($this$withActionIcon) {
  return ActionImportance_Important_getInstance();
}
function *_generator_invoke__zhh2q8_23($this, $this$withActionIcon, $completion) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.wi0_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.kfy().equals($this.xi0_1.kfy())) {
      destination.v(element);
    }
  }
  var tmp = destination;
  var tmp_0 = awaitSuspending($this.yi0_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = awaitSuspending($this.zi0_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  navigateOrDialog($this.vi0_1, new (ScopeSetReviewDialog())(tmp, tmp_0, tmp_1, true));
  return Unit_instance;
}
var scopeSetActions$lambda$slambdaClass_6;
function scopeSetActions$lambda$slambda_13() {
  if (scopeSetActions$lambda$slambdaClass_6 === VOID) {
    class $ {
      constructor($$this$with, $lineItems, $lineItem, $itemMessages, $scope) {
        this.vi0_1 = $$this$with;
        this.wi0_1 = $lineItems;
        this.xi0_1 = $lineItem;
        this.yi0_1 = $itemMessages;
        this.zi0_1 = $scope;
      }
      wah($this$withActionIcon, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this, $this$withActionIcon), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    scopeSetActions$lambda$slambdaClass_6 = $;
  }
  return scopeSetActions$lambda$slambdaClass_6;
}
function scopeSetActions$lambda$slambda_14($$this$with, $lineItems, $lineItem, $itemMessages, $scope) {
  var i = new (scopeSetActions$lambda$slambda_13())($$this$with, $lineItems, $lineItem, $itemMessages, $scope);
  var l = ($this$withActionIcon, $completion) => i.wah($this$withActionIcon, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_24($this, move, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ai1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.hf9_1;
    destination.v(tmp$ret$1);
  }
  var tmp_0 = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$4 = tmp_1;
  var tmp_2 = reorder(move, tmp_0, tmp$ret$4.mfv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgtyClass;
function renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgty() {
  if (renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgtyClass === VOID) {
    class $ {
      constructor($items) {
        this.ai1_1 = $items;
      }
      dhm(move, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_24.bind(VOID, this, move), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgtyClass = $;
  }
  return renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgtyClass;
}
function renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgty_0($items) {
  var i = new (renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$slambda_a4kgty())($items);
  var l = (move, $completion) => i.dhm(move, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_25($this, $this$launch, $completion) {
  var tmp = JumpTo_getInstance().rg3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bi1_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.kf9_1;
  tmp.xg4(tmp_1, $this.ci1_1, VOID, () => {
    $this.di1_1.mam(true);
    var tmp0_safe_receiver = $this.ei1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      set_value(tmp0_safe_receiver, true);
    }
    $this.fi1_1.mam(true);
    return Unit_instance;
  });
  return Unit_instance;
}
var renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3Class;
function renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3() {
  if (renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3Class === VOID) {
    class $ {
      constructor($item, $row, $expand, $expandOnJump, $expandItem) {
        this.bi1_1 = $item;
        this.ci1_1 = $row;
        this.di1_1 = $expand;
        this.ei1_1 = $expandOnJump;
        this.fi1_1 = $expandItem;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_25.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3Class = $;
  }
  return renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3Class;
}
function renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3_0($item, $row, $expand, $expandOnJump, $expandItem) {
  var i = new (renderScopeViewWide$_anonymous_$_anonymous_$_anonymous_$_anonymous_$renderItems$lambda$slambda_cnkdr3())($item, $row, $expand, $expandOnJump, $expandItem);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  deleteScopeConfirmation as deleteScopeConfirmation1ansau13nxp5t,
  renderScopeView as renderScopeView29s6jurmhfcza,
  scopeSetActions as scopeSetActionsy67y5wxparae,
  scopeViewRetryWarningBanner as scopeViewRetryWarningBanner2txar3lw1tei9,
};
//endregion

//# sourceMappingURL=renderScopeView.mjs.map
